// src/hooks/useWeeklyReport.ts
import { useState } from 'react';
import { getWeeklyDrivingReport, getWeeklyDrivingReportPDF as fetchWeeklyReportPDFService } from '../api/services/weeklyReport';
import { WeeklyDrivingReport } from '../api/types/weeklyDrivingReport';
import { useQuery } from '@tanstack/react-query';


const debugLog = (...args: any[]) => {
  if (__DEV__) console.log(...args);
};

export const useWeeklyReport = () => {
  const [weekStart, setWeekStart] = useState<string | undefined>(undefined);
  const {
    data: report,
    isLoading: loading,
    isError,
    error: queryError,
  } = useQuery<WeeklyDrivingReport>({
    queryKey: ['weeklyReport', weekStart],
    queryFn: () => getWeeklyDrivingReport(weekStart),
  });

  const getWeeklyDrivingReportPDF = (weekStart?: string): Promise<Blob> => {
    return fetchWeeklyReportPDFService(weekStart);
  };

  return {
    report,
    loading,
    error: isError ? (queryError as Error).message : null,
    fetchReport: (newWeekStart?: string) => {
      debugLog('useWeeklyReport: fetchReport called with:', newWeekStart);
      setWeekStart(newWeekStart);
    },
    getWeeklyDrivingReportPDF,
  };
};